module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container font-size-control pt-3 pb-3",
    attrs: {
      "id": "pictureVocabulary"
    }
  }, [_c('div', {
    staticClass: "row d-flex align-items-center"
  }, [_c('div', {
    staticClass: "col-1 clickable",
    on: {
      "click": function($event) {
        _vm.pageLeft()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-2x"
  })]), _vm._v(" "), (_vm.page > -1) ? _c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "text-center p-3"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentPage.image,
      "width": "90%"
    }
  })]), _vm._v(" "), _c('h4', {
    class: {
      'h4': true, 'clickable': _vm.currentPage.audio
    },
    on: {
      "click": function($event) {
        _vm.playAudioFile(_vm.currentPage.audio)
      }
    }
  }, [(_vm.currentPage.audio) ? _c('span', [_c('i', {
    staticClass: "fa fa-volume-up"
  })]) : _vm._e(), _vm._v(" " + _vm._s(_vm.currentPage.name) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "pron"
  }, [_vm._v(_vm._s(_vm.currentPage.pronouncing))]), _c('br'), _vm._v("\n      " + _vm._s(_vm.currentPage.partOfSpeech) + " " + _vm._s(_vm.currentPage.name_i18N[0].value)), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.currentPage.examples), function(example, exampleIndex) {
    return _c('p', {
      key: exampleIndex,
      class: {
        'clickable': example.audio
      },
      on: {
        "click": function($event) {
          _vm.playAudioFile(example.audio)
        }
      }
    }, [(example.audio) ? _c('span', [_c('i', {
      staticClass: "fa fa-volume-up"
    })]) : _vm._e(), _vm._v(" " + _vm._s(example.text)), _c('br'), _vm._v(" "), _vm._l((example.text_i18N), function(lang, langIndex) {
      return _c('span', {
        key: langIndex
      }, [_vm._v(_vm._s(lang.value))])
    })], 2)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-1 clickable",
    on: {
      "click": function($event) {
        _vm.pageRight()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right fa-2x"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07c49fc1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/PictureVocabulary.vue
// module id = 703
// module chunks = 1